/**
 * English translations for the QR Phone resources
 */

export const qrphoneResourcesEn = {
  clients: {
    name: 'Client |||| Clients',
    fields: {
      full_name: 'Name',
      email: 'Email',
      password: 'Password',
      company_name: 'Company',
      contact_no: 'Phone',
      plan_id: 'Plan',
      status: 'Status',
    },
    plan_help:
      'Select a plan. Without an assigned plan, the client will not be able to sign in.',
    activation_note:
      'An email will be sent to the client so they can set their password and sign in. No password needs to be assigned here.',
  },
  signupRequests: {
    name: 'Sign-up request |||| Sign-up requests',
    fields: {
      full_name: 'Full name',
      email: 'Email',
      company_name: 'Company',
      contact_no: 'Phone',
      plan_id: 'Requested plan',
      created_at: 'Requested on',
      state: 'State',
      notes: 'Notes',
    },
    states: {
      pending: 'Pending',
      converted: 'Converted',
      rejected: 'Rejected',
    },
    actions: {
      convert: 'Convert into a client',
      reject: 'Reject',
    },
    confirm: {
      reject_title: 'Reject the request',
      reject_content: 'Reject this request? The decision is final and cannot be undone.',
    },
    notifications: {
      converted: 'Request converted into a client',
      rejected: 'Request rejected',
      already_decided: 'Someone else had already resolved this request. The list has been refreshed.',
      decision_failed: 'The request could not be resolved. Please try again.',
      convert_orphan:
        'The client was created, but the request could not be marked as converted. Please review it in the list.',
    },
  },
  orgManagers: {
    name: 'Organization manager |||| Organization managers',
    fields: {
      full_name: 'Name',
      email: 'Email',
      password: 'Password',
      contact_no: 'Phone',
      organization_id: 'Organization',
      organizations_array: 'Organizations',
      status: 'Status',
    },
  },
  connections: {
    name: 'Connection |||| Connections',
    fields: {
      user_name: 'User',
      user_email: 'Email',
      login_connection_date: 'Sign-in',
      login_connection_device_os: 'Device',
      logout_connection_date: 'Sign-out',
    },
  },
  admins: {
    name: 'Administrator |||| Administrators',
    fields: {
      full_name: 'Name',
      email: 'Email',
      password: 'Password',
      contact_no: 'Phone',
      status: 'Status',
      last_login: 'Last login',
    },
  },
  qrUserDetails: {
    name: 'Caller field |||| Caller fields',
    types: {
      text: 'Text',
      email: 'Email',
      phone: 'Phone',
      number: 'Number',
    },
    fields: {
      field_name: 'Field name',
      type: 'Type',
    },
  },
  plans: {
    name: 'Plan |||| Plans',
    stripe_note: 'Name or price changes are synced automatically with the payment gateway.',
    types: {
      individual: 'Individual',
      company: 'Company',
    },
    durations: {
      monthly: 'Monthly (30 days)',
      yearly: 'Yearly (365 days)',
    },
    fields: {
      name: 'Name',
      description: 'Description',
      tagline: 'Tagline',
      price: 'Price (€)',
      plan_type: 'Type',
      duration: 'Duration',
      is_qr_type_static: 'Allows static QR',
      is_qr_type_dynamic: 'Allows dynamic QR',
      static_qr_limit: 'Static QR limit',
      dynamic_qr_limit: 'Dynamic QR limit',
      staff_member_limit: 'Staff limit',
      modules: 'Modules',
    },
  },
  transactions: {
    name: 'Payment |||| Payments',
    status: {
      paid: 'Paid',
      pending: 'Pending',
    },
    fields: {
      created_on: 'Date',
      user_id: 'Client',
      plan_id: 'Plan',
      plan_price: 'Amount',
      plan_start_date: 'Plan start',
      plan_end_date: 'Plan end',
      payment_status: 'Payment status',
      is_active: 'Active',
    },
  },
  organizations: {
    name: 'Organization |||| Organizations',
    fields: {
      client_id: 'Owning client',
      password: 'Password',
      full_name: 'Name',
      email: 'Email',
      company_name: 'Company',
      contact_no: 'Phone',
      address: 'Address',
      city: 'City',
      postal_code: 'Postal code',
      status: 'Status',
      createdAt: 'Created',
    },
  },
  staff: {
    name: 'Staff member |||| Staff',
    plan_limit_note: 'Staff creation is subject to the member limit of the contracted plan.',
    activation_note:
      'An email will be sent to the person so they can set their password and sign in. No password needs to be assigned here.',
    invite: {
      button: 'Invite',
      title: 'Invite a user to an organization',
      send: 'Send invitation',
      success: 'Invitation sent',
    },
    remove_org: {
      button: 'Remove from an organization',
      title: 'Remove from organization',
      success: 'Member removed from the organization',
    },
    fields: {
      password: 'Password',
      full_name: 'Name',
      email: 'Email',
      contact_no: 'Phone',
      organization_id: 'Organization',
      department_id: 'Schedule',
      status: 'Status',
      last_login: 'Last login',
      createdAt: 'Created',
    },
  },
  departments: {
    name: 'Schedule |||| Schedules',
    fields: {
      name: 'Name',
      description: 'Description',
      organization_id: 'Organization',
      start_shift: 'Shift start',
      end_shift: 'Shift end',
      weekdays: 'Weekdays',
      'user.full_name': 'Created by',
    },
  },
  userGroupOrganization: {
    name: 'Staff assignment |||| Staff assignments',
    fields: {
      organization_id: 'Organization',
      group_id: 'Schedule',
      staff_id: 'Staff',
      is_primary: 'Primary',
      'organization.full_name': 'Organization',
      'department.name': 'Schedule',
      'staff.full_name': 'Staff',
    },
  },
  qrcodes: {
    name: 'QR code |||| QR codes',
    plan_limit_note: 'QR code creation is subject to the limits of the contracted plan (static and dynamic).',
    types: {
      static: 'Static',
      dynamic: 'Dynamic',
    },
    actions: {
      download: 'Download image',
    },
    no_image: 'This QR code has no generated image.',
    department_help:
      'The QR code rings the staff assigned to these schedules (by weekday and time window). Staff-to-schedule assignments are managed under "Staff assignment".',
    staffs_help:
      'Staff who receive the call directly, in addition to those assigned through the schedules.',
    default_staff_help:
      'Only agents with an active device able to answer calls can be selected. The default staff receives the call when the assigned staff do not answer.',
    default_staff_warning:
      'The selected default staff cannot answer calls (not an agent with an active device). This kiosk may not receive calls.',
    default_staff_cannot_answer_suffix: 'cannot answer calls',
    show_callback_form_help:
      'Shows a contact form to the caller when no staff are available to answer. Makes sense when the person scans the code from their own phone, but not on an unattended kiosk with no keyboard, where it should be turned off.',
    fields: {
      staffs: 'Assigned staff',
      deptArr: 'Schedules',
      no_expiry: 'Never expires',
      enabledDirectCall: 'Direct call',
      showCallbackForm: 'Contact form',
      public_link: 'Public link',
      qr_name: 'Name',
      type: 'Type',
      status: 'Status',
      organization_id: 'Organization',
      department_id: 'Schedules',
      default_staff_id: 'Default staff',
      default_staff_name: 'Default staff',
      qr_start_time: 'Valid from',
      qr_end_time: 'Valid until',
      createdAt: 'Created',
    },
  },
  callDetails: {
    name: 'Call |||| Call history',
    filters: {
      q: 'Search',
      date_from: 'From',
      date_to: 'To',
      organization: 'Organization',
      staff: 'Staff',
      status: 'Status',
    },
    connection: {
      yes: 'Attended',
      no: 'Not attended',
    },
    status: {
      CALL_ENDED: 'Ended',
      ANSWER_CALL: 'Answered',
      MISSED_CALL: 'Missed',
      NO_ANSWER: 'No answer',
      CALL_REJECTED: 'Rejected',
      REJTD: 'Rejected (device)',
      QUEUED: 'Queued',
      QUEUE_TIMEOUT: 'Queue timeout',
      STAFF_UNAVAILABLE: 'Staff unavailable',
      CONNECTION_ERROR: 'Connection error',
    },
    export: {
      empty: 'There is no data to export with the current filters',
      capped: 'The export is limited to the 1000 most recent calls',
    },
    fields: {
      caller: 'Caller',
      start_time: 'Date & time',
      end_time: 'End',
      user_info: 'Caller',
      user_name: 'Attended by',
      user_id: 'Attended by',
      organization_id: 'Organization',
      qrcode_id: 'QR code',
      callstatus: 'Status',
      duration: 'Duration',
      booking_id: 'Booking',
      isCallConnected: 'Connected',
    },
  },
};

export default qrphoneResourcesEn;
